import { logError } from '@ecomm/error-handling'
import type React from 'react'

declare global {
  var ___loader:
    | {
        readonly hovering: (to: string) => void
      }
    | undefined
  var ___navigate:
    | ((
        to: string,
        options?: { readonly state?: Record<string, unknown> }
      ) => void)
    | undefined
}

export type NavigationState = Record<string, unknown>

export const gatsbyNavigate = (
  to: string,
  options?: { readonly state?: NavigationState; readonly replace?: boolean }
) => {
  try {
    globalThis.window?.___navigate?.(to, options)
  } catch (err) {
    logError(err instanceof Error ? err : new Error(String(err)))
  }
}

// taken from https://github.com/gatsbyjs/gatsby/blob/gatsby-link%405.12.1/packages/gatsby-link/src/index.js#L182
const shouldPreventDefault = (
  e: React.MouseEvent<HTMLAnchorElement>,
  target?: React.HTMLAttributeAnchorTarget
) => {
  return (
    e.button === 0 && // ignore right clicks
    !target && // let browser handle "target=_blank"
    !e.defaultPrevented && // onClick prevented default
    !e.metaKey && // ignore clicks with modifier keys
    !e.altKey &&
    !e.ctrlKey &&
    !e.shiftKey
  )
}

export const gatsbyOnLinkClick = (
  url: string,
  options: {
    readonly state?: Record<string, unknown>
    readonly target?: React.HTMLAttributeAnchorTarget
    readonly onClick?: React.MouseEventHandler<HTMLAnchorElement>
  }
) => {
  return (e: React.MouseEvent<HTMLAnchorElement>) => {
    options.onClick?.(e)

    if (shouldPreventDefault(e, options.target)) {
      e.preventDefault()
      gatsbyNavigate(url, { state: options.state })
    }
  }
}

export const gatsbyOnMouseEnter = (
  url: string,
  onMouseEnter?: React.MouseEventHandler<HTMLAnchorElement>
) => {
  return (e: React.MouseEvent<HTMLAnchorElement>) => {
    onMouseEnter?.(e)
    globalThis.window?.___loader?.hovering(url)
  }
}
